"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncompleteCartTypes = void 0;
var IncompleteCartTypes;
(function (IncompleteCartTypes) {
    IncompleteCartTypes["DEFAULT_INCOMPLETE"] = "DEFAULT_INCOMPLETE";
    IncompleteCartTypes["DTVS_ADDON"] = "DTVS_ADDON";
    IncompleteCartTypes["WLS_DEVICE"] = "WLS_DEVICE";
    IncompleteCartTypes["WLS_PLAN"] = "WLS_PLAN";
    IncompleteCartTypes["IPTV_ADDON"] = "IPTV_ADDON";
    IncompleteCartTypes["WLS_DEVICE_CELLPHONE"] = "WLS_DEVICE_CELLPHONE";
})(IncompleteCartTypes = exports.IncompleteCartTypes || (exports.IncompleteCartTypes = {}));
//# sourceMappingURL=IncompleteCartProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/atoms/IncompleteCart/IncompleteCartProps.js
// module id = 2328
// module chunks = 8